

const getStringWithWildcards = (input, wildcardBefore = true, wildcardAfter = true) => {
	return [wildcardBefore ? "*" : "", input, wildcardAfter ? "*" : ""].join("");
};

export default getStringWithWildcards;